import { Banner, Box, Divider, FlexBox, Text } from '@dixa/lib-shared-habla';

import { useHasFeature } from 'components/shared/featureFlag';

import styles from './SuggestionListPlaceholder.module.scss';

export const PlaceholderPage = (): JSX.Element => {
  return <Box height="16px" width="16px" className={styles.placeholder} />;
};

function SuggestionRowPlaceholder(): JSX.Element {
  return (
    <FlexBox
      gap="300"
      alignItems="center"
      width="100%"
      className={styles.placeholderRow}
    >
      <Box height="36px" width="4px" className={styles.placeholder} />
      <FlexBox
        flexDirection="column"
        gap="5px"
        className={styles.placeholderTitleWrapper}
      >
        <Box height="14px" width="160px" className={styles.placeholder} />
        <FlexBox gap="4px" alignItems="center">
          <Box height="12px" width="60px" className={styles.placeholder} />
          <Box height="4px" width="4px" className={styles.placeholder} />
          <Box height="12px" width="60px" className={styles.placeholder} />
        </FlexBox>
      </FlexBox>
      <Box height="16px" width="16px" className={styles.placeholder} />
      <Box height="16px" width="16px" className={styles.placeholder} />
    </FlexBox>
  );
}

function PaginationPlaceholder() {
  return (
    <FlexBox
      gap="300"
      justifyContent="center"
      className={styles.placeholderPagination}
    >
      <PlaceholderPage />
      <PlaceholderPage />
      <PlaceholderPage />
      <PlaceholderPage />
      <PlaceholderPage />
    </FlexBox>
  );
}

export function SuggestionsLoadingPlaceholder(): JSX.Element {
  return (
    <FlexBox gap="300" flexDirection="column">
      <SuggestionRowPlaceholder />
      <Divider />
      <SuggestionRowPlaceholder />
      <Divider />
      <SuggestionRowPlaceholder />
      <Divider />
      <SuggestionRowPlaceholder />
      <Divider />
      <SuggestionRowPlaceholder />
      <PaginationPlaceholder />
    </FlexBox>
  );
}

function ContactViaEmailLink() {
  return (
    <>
      <Text.ExternalLink
        href="mailto:support@dixa.com?subject=Dixa Knowledge Base - Enquiry"
        target="_blank"
        rel="noreferrer"
        className={styles.link}
      >
        Contact our support team
      </Text.ExternalLink>{' '}
      to get set up.
    </>
  );
}
function ContactViaMessenger() {
  function openWidget() {
    window._dixa_?.invoke('setWidgetOpen', true);
  }

  return (
    <>
      <Text.ExternalLink onClick={openWidget} className={styles.link}>
        Contact our support team
      </Text.ExternalLink>{' '}
      to get set up.
    </>
  );
}

export function SuggestionsNotEnabledPlaceholder(): JSX.Element {
  const hasChatWithDixaSupport = useHasFeature('has-chat-with-dixa-support');

  return (
    <Banner
      className={styles.suggestionsNotEnabled}
      variant="announcement"
      headline={'Instant Answers'}
      description={
        <>
          <Text.Paragraph
            subdued={true}
            variant="4"
            className={styles.suggestionsNotEnabledContent}
          >
            {
              "Display contextually relevant knowledge base content here to help guide you and the customer when you're responding to conversations."
            }
          </Text.Paragraph>
          <Text.Paragraph
            subdued={true}
            variant="4"
            className={styles.suggestionsNotEnabledContent}
          >
            {hasChatWithDixaSupport ? (
              <ContactViaMessenger />
            ) : (
              <ContactViaEmailLink />
            )}
          </Text.Paragraph>
        </>
      }
    />
  );
}

type SuggestionsNotFoundPlaceholderProps = {
  description: string;
  headline: string;
};
export function SuggestionsNotFoundPlaceholder({
  description,
  headline,
}: SuggestionsNotFoundPlaceholderProps): JSX.Element {
  return (
    <Banner
      className={styles.suggestionsNotEnabled}
      variant="warning"
      headline={headline}
      description={
        <Text.Paragraph
          subdued={true}
          variant="4"
          className={styles.suggestionsNotEnabledContent}
        >
          {description}
        </Text.Paragraph>
      }
    />
  );
}
